// Reference API (spec §2): banks, branches, IFSC, countries, currencies,
// recharge and bill lists, locations and legal documents.
import type { BankRef, BranchLocation, BranchRef, CountryRef } from '@/types/phase2.types';
import { ApiError } from './client';
import { MOCK_REFERENCE, REAL_API_ENABLED } from './flags';
import * as mock from '@/mock/handlers/reference';

// A rejected promise, not a throw: callers use .catch(), and a synchronous throw
// inside a screen's effect blanks the whole page.
const notAvailable = <T>(): Promise<T> =>
  Promise.reject(new ApiError('NOT_AVAILABLE', 'The reference API is not available yet.'));

// The server has no bank directory. Banks and branches are display data, so
// real mode serves the same static catalogue.
const STATIC_BANK_DIRECTORY = MOCK_REFERENCE || REAL_API_ENABLED;

export const getBanks = (): Promise<BankRef[]> => (STATIC_BANK_DIRECTORY ? mock.getBanks() : notAvailable());
export const getBranches = (bankCode: string): Promise<BranchRef[]> =>
  STATIC_BANK_DIRECTORY ? mock.getBranches(bankCode) : notAvailable();
export const findBranchByIfsc = (ifsc: string): Promise<{ bank: BankRef; branch: BranchRef } | null> =>
  STATIC_BANK_DIRECTORY ? mock.findBranchByIfsc(ifsc) : notAvailable();
export const getCountries = (): Promise<CountryRef[]> =>
  STATIC_BANK_DIRECTORY ? mock.getCountries() : notAvailable();
export const getOperators = (): Promise<string[]> =>
  MOCK_REFERENCE ? mock.getOperators() : notAvailable();
export const getCircles = (): Promise<string[]> =>
  MOCK_REFERENCE ? mock.getCircles() : notAvailable();
export const getBillCategories = (): Promise<string[]> =>
  MOCK_REFERENCE ? mock.getBillCategories() : notAvailable();
export const getBillers = (category: string): Promise<string[]> =>
  MOCK_REFERENCE ? mock.getBillers(category) : notAvailable();
export const getLocations = (): Promise<BranchLocation[]> =>
  MOCK_REFERENCE ? mock.getLocations() : notAvailable();
export const getLegalDocument = (type: string): Promise<string> =>
  MOCK_REFERENCE ? mock.getLegalDocument(type) : notAvailable();
